// extracted by mini-css-extract-plugin
export var serviceCard = "service-card-module--service-card--wARc-";
export var serviceCardActive = "service-card-module--service-card--active--uKrew";